import gql from 'graphql-tag';


export const WS_APPOINTMENTS_GROUP_UPDATE = gql`
  subscription($userId: String!, $groupIds: [String!]!) {
    appointmentGroupUpdate(userId: $userId, groupIds: $groupIds) {
      groupId
      currentAppointmentId
      appointments {
        appointmentId
        subject {
          subjectId
          userId
          description
          externalUserId
          user {
            userId
            type
            profile {
              firstName
              middleName
              lastName
              title
              gender
              avatar
              policyId
              externalId
            }
          }
        }
        status
        version
        groupPosition
      }
    }
  }
`;
